import React from "react";
import ReactDOM from "react-dom/client"; // React 18 method
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { SidebarProvider } from './SidebarContext';
import ErrorBoundary from './components/ErrorBoundary';

// Create root and render App with BrowserRouter
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <SidebarProvider>
        <App />
      </SidebarProvider>
    </BrowserRouter>
  </ErrorBoundary>
);
